/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import BarSortingPagination from '../../components/dashboard/bar/pagination';
import BarSorting from '../../components/dashboard/bar/sorting';
import BarUser from '../../components/dashboard/bar/user';
import BarFilter from '../../components/dashboard/bar/filter';
import {getAuthUser} from '../../store/auth/selectors';
import {
    setCustomFilter,
    setErpFilter,
    setOrderFilter,
    setOverlay,
    tasksInitSortingPagination,
    tasksSetSorting,
    tasksSetSortingPagination,
} from '../../store/tasks/actions';
import {
    getTasksFormattedSortingPaginationValue,
    getTasksSorting,
    getTasksSortingPaginationValue
} from '../../store/tasks/selectors';
import {getSortingInitialValue, getSortingNextValue, getSortingPrevousValue} from '../../store/tasks/utilities';

const BarWrapper = styled.div`
	display:flex;
	justify-content: space-between;
	min-height: 37px;
	align-items: center;
	box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.1);
	border-top: 1px solid #e4e5e6;
`;

class Bar extends React.Component {
    componentDidMount() {
        const {sorting, paginationValue, tasksInitSortingPagination} = this.props;
        if (!paginationValue) tasksInitSortingPagination(sorting);
    }

    updateSortingPagination = (method) => {
        const {sorting, paginationValue, tasksSetSortingPagination} = this.props;
        tasksSetSortingPagination(method(sorting, paginationValue));
    };

    filterTasks = (filter, value) => {
        const {setErpFilter, setOrderFilter, setCustomFilter} = this.props;
        // setErpFilter(erp);
        // setOrderFilter(order);
        setCustomFilter(filter, value);
    }

    render() {
        const {user, sorting, paginationValue, formattedPaginationValue, tasksSetSorting, setOverlay} = this.props;

        // if (!user || !sorting || !paginationValue) {
        // 	return null;
        // }

        return (
            <BarWrapper>
                <BarSortingPagination
                    pagingValue={formattedPaginationValue}
                    handlePrevClick={() => this.updateSortingPagination(getSortingPrevousValue)}
                    handleNextClick={() => this.updateSortingPagination(getSortingNextValue)}
                    handleCurrentClick={() => this.updateSortingPagination(getSortingInitialValue)}
                />

                <BarSorting
                    currentSort={sorting}
                    updateSorting={tasksSetSorting}
                />
                <BarFilter filter={this.filterTasks} pagingValue={paginationValue}/>
                <BarUser user={user} click={() => setOverlay({task: {}, type: 'logout'})}/>
            </BarWrapper>
        );
    }
}

export default connect(
    (state) => ({
        user: getAuthUser(state),
        sorting: getTasksSorting(state),
        paginationValue: getTasksSortingPaginationValue(state),
        formattedPaginationValue: getTasksFormattedSortingPaginationValue(state),
    }), {
        tasksSetSorting,
        tasksSetSortingPagination,
        tasksInitSortingPagination,
        setOverlay,
        setErpFilter,
        setOrderFilter,
        setCustomFilter,
    }
)(Bar);



// WEBPACK FOOTER //
// ./src/containers/dashboard/bar.js